import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import "../../../style/persona-datagrid.css";
import cargandoCard from "../../../components/cargando-card";
import { actualizarPersona, crearPersona } from "../../../api/api-persona";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import ModalTelefono from "../../../components/modal-telefono";
import ModalEmail from "../../../components/modal-email";

let $ = window.$;

/** MySQL JSON columns may arrive as string or parsed array */
function parseJsonArrayField(raw) {
  if (raw == null || raw === "") {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw;
  }
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

function normalizeContactRows(arr) {
  if (!Array.isArray(arr)) {
    return [];
  }
  return arr.map((row, idx) => ({
    id: row.id != null ? row.id : -(idx + 1),
    codigo: row.codigo ?? "",
    descripcion: row.descripcion ?? "",
    nota: row.nota ?? "",
  }));
}

export default function PersonaPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [rowsDataTelefonos, setRowsDataTelefonos] = useState([]);
  const [showModalTelefono, setShowModalTelefono] = useState(false);
  const [telefonoFormData, setTelefonoFormData] = useState({
    codigo: "",
    descripcion: "",
    nota: "",
  });

  const [rowsDataEmail, setRowsDataEmail] = useState([]);
  const [showModalEmail, setShowModalEmail] = useState(false);
  const [emailFormData, setEmailFormData] = useState({
    codigo: "",
    descripcion: "",
    nota: "",
  });

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log('data');
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
        const telRaw = data.params?.telefonos;
        const emailRaw = data.params?.correos;
        setRowsDataTelefonos(normalizeContactRows(parseJsonArrayField(telRaw)));
        setRowsDataEmail(normalizeContactRows(parseJsonArrayField(emailRaw)));
      }
    } catch (err) {
      console.log("iniciar err");
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  useEffect(() => {
    if (cargandoPage) {
      return;
    }
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainerTelefonos");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            gridInstance.option("dataSource", rowsDataTelefonos);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGridTelefonos();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGridTelefonos();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsDataTelefonos, cargandoPage]);

  useEffect(() => {
    if (cargandoPage) {
      return;
    }
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainerEmail");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            gridInstance.option("dataSource", rowsDataEmail);
          } else {
            inicializarGridEmail();
          }
        } catch (e) {
          inicializarGridEmail();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsDataEmail, cargandoPage]);

  const inicializarGridTelefonos = () => {
    try {
      const gridElement = $("#gridContainerTelefonos");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsDataTelefonos,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        scrolling: {
          mode: "standard",
          showScrollbar: "onHover",
          useNative: true,
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 180,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate(container, options) {
              const buttonContainer = $("<div>").addClass("flex gap-2");
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", () => {
                  modificarTelefonoSelected(options.data);
                })
                .appendTo(buttonContainer);
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                )
                .text(t("label_eliminar"))
                .on("click", () => {
                  eliminarTelefonoSelected(options.data);
                })
                .appendTo(buttonContainer);
              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
        ],
      });
    } catch (err) {
      console.error("Error initializing grid telefonos:", err);
    }
  };

  const inicializarGridEmail = () => {
    try {
      const gridElement = $("#gridContainerEmail");

      if (!gridElement.length) {
        return;
      }

      gridElement.dxDataGrid({
        dataSource: rowsDataEmail,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        scrolling: {
          mode: "standard",
          showScrollbar: "onHover",
          useNative: true,
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 180,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate(container, options) {
              const buttonContainer = $("<div>").addClass("flex gap-2");
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", () => {
                  modificarEmailSelected(options.data);
                })
                .appendTo(buttonContainer);
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                )
                .text(t("label_eliminar"))
                .on("click", () => {
                  eliminarEmailSelected(options.data);
                })
                .appendTo(buttonContainer);
              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
        ],
      });
    } catch (err) {
      console.error("Error initializing grid email:", err);
    }
  };

  const modificarTelefonoSelected = (data) => {
    setTelefonoFormData({ ...data });
    setShowModalTelefono(true);
  };

  const eliminarTelefonoSelected = (data) => {
    setRowsDataTelefonos((prev) => prev.filter((item) => item.id !== data.id));
  };

  const modificarEmailSelected = (data) => {
    setEmailFormData({ ...data });
    setShowModalEmail(true);
  };

  const eliminarEmailSelected = (data) => {
    setRowsDataEmail((prev) => prev.filter((item) => item.id !== data.id));
  };

  const handleNuevoTelefonoClick = () => {
    setTelefonoFormData({
      id: (rowsDataTelefonos.length + 1) * -1,
      codigo: "",
      descripcion: "",
      nota: "",
    });
    setShowModalTelefono(true);
  };

  const handleOnAcceptTelefono = (data) => {
    setShowModalTelefono(false);
    const existe = rowsDataTelefonos.find((item) => item.id === data.id);
    if (existe) {
      setRowsDataTelefonos((prev) =>
        prev.map((item) => (item.id === data.id ? { ...data } : item))
      );
    } else {
      setRowsDataTelefonos((prev) => [...prev, { ...data }]);
    }
    setTelefonoFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const handleTelefonoCancel = () => {
    setShowModalTelefono(false);
    setTelefonoFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const handleNuevoEmailClick = () => {
    setEmailFormData({
      id: (rowsDataEmail.length + 1) * -1,
      codigo: "",
      descripcion: "",
      nota: "",
    });
    setShowModalEmail(true);
  };

  const handleOnAcceptEmail = (data) => {
    setShowModalEmail(false);
    const existe = rowsDataEmail.find((item) => item.id === data.id);
    if (existe) {
      setRowsDataEmail((prev) =>
        prev.map((item) => (item.id === data.id ? { ...data } : item))
      );
    } else {
      setRowsDataEmail((prev) => [...prev, { ...data }]);
    }
    setEmailFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const handleEmailCancel = () => {
    setShowModalEmail(false);
    setEmailFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (!formData) {
      return;
    }
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData?.descripcion ?? "").trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + "\n";
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log("validarFormulario err");
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.telefonos = rowsDataTelefonos;
    objEnviar.correos = rowsDataEmail;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setProcessingVisible(true);
    if (formData.id === 0) {
      const response = await crearPersona(objEnviar);
      setProcessingVisible(false);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      const response = await actualizarPersona(objEnviar);
      setProcessingVisible(false);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData?.codigo ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.codigo?.length ?? 0}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="descripcion"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData?.descripcion ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.descripcion?.length ?? 0}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData?.nota ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.nota?.length ?? 0}/{charLimits.nota}</p>
              </div>
            </div>
            <br />
            {/* Grid Card Telefonos */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between items-center">
                  <label className="block text-md font-medium text-gray-700" htmlFor="gridContainerTelefonos">
                    {t("label_telefonos")}
                  </label>
                  <button
                    type="button"
                    className={ESTILO_BOTON_LISTAR_NUEVO}
                    onClick={() => {
                      handleNuevoTelefonoClick();
                    }}
                  >
                    {t("label_nuevo")}
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="persona-grid-host h-[400px] rounded-lg overflow-hidden">
                  <div
                    id="gridContainerTelefonos"
                    className="h-full w-full"
                  />
                </div>
              </div>
            </div>
            <br />
            {/* Grid Card Email */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between items-center">
                  <label className="block text-md font-medium text-gray-700" htmlFor="gridContainerEmail">
                    {t("label_email")}
                  </label>
                  <button
                    type="button"
                    className={ESTILO_BOTON_LISTAR_NUEVO}
                    onClick={() => {
                      handleNuevoEmailClick();
                    }}
                  >
                    {t("label_nuevo")}
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="persona-grid-host h-[400px] rounded-lg overflow-hidden">
                  <div
                    id="gridContainerEmail"
                    className="h-full w-full"
                  />
                </div>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
          <ModalTelefono
            isOpen={showModalTelefono}
            formData={telefonoFormData}
            setFormData={setTelefonoFormData}
            onAccept={handleOnAcceptTelefono}
            onCancel={handleTelefonoCancel}
          />
          <ModalEmail
            isOpen={showModalEmail}
            formData={emailFormData}
            setFormData={setEmailFormData}
            onAccept={handleOnAcceptEmail}
            onCancel={handleEmailCancel}
          />
        </div>
      );
    } catch (err) {
      console.log("formData render err");
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  };

  return render();
}
